import { useEffect, useState } from "react";
import { useTheme } from "../../../components/hooks/useTheme";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import { CustomDataGrid } from "../../../components/common/CustomDataGrid";
import baseURL from "../../../configs/api";
import axios from "axios";
import { Build, Done, ContentCut, WatchLater } from "@mui/icons-material";
import useConfirm from "../../../components/hooks/useConfirm";
import useAuth from "../../../components/hooks/useAuth";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

type MaintenanceListProps = {
    paginationModel: any;
    setPaginationModel: (value: any) => void;
    searchValue: string;
    setSearchValue: (value: string) => void;
    maintenanceFilterValue: number;
    setMaintenanceFilterValue: (value: number) => void;
    selectedFilter: string;
    setSelectedFilter: (value: string) => void;
    filterItems: any[]
}

export const MaintenanceList = ({
    paginationModel,
    setPaginationModel,
    searchValue,
    setSearchValue,
    maintenanceFilterValue,
    setMaintenanceFilterValue,
    selectedFilter,
    setSelectedFilter,
    filterItems
}: MaintenanceListProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const navigate = useNavigate();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [loading, setLoading] = useState(true);
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [columnFilterAnchorEl, setColumnFilterAnchorEl] = useState<null | HTMLElement>(null);
    const columnFilterOpen = Boolean(columnFilterAnchorEl);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const initialColumns: GridColDef[] = [
        {
            field: "id",
            headerName: "#",
            width: 120,
            editable: false,
            sortable: false,
            align: "left",
        },
        {
            field: "vehicleName",
            headerName: "Vehicle",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "maintenanceTypeName",
            headerName: "Maintenance Type",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "lastMaintenaceDate",
            headerName: "Last Maintenace Date",
            align: "left",
            width: 150,
            editable: false,
            sortable: false,
        },
        {
            field: "lastMaintenaceOdometer",
            headerName: "Last Maintenace Odometer",
            align: "left",
            editable: false,
            sortable: false,
            width: 300,
        },
        {
            field: "nextMaintenaceOdometer",
            headerName: "Next Maintenace Odometer",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "maintenanceStatusName",
            headerName: "Status",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                let color = {
                    colorBg: "#000000",
                    colorText: "#000000"
                };
                switch (params?.row?.maintenanceStatusId) {
                    case 1:
                        color = {
                            colorBg: "bg-[#F3CBA9]",
                            colorText: "text-[#DE6F0D]"
                        }
                        break;
                    case 2:
                        color = {
                            colorBg: "bg-[#FEDFDD]",
                            colorText: "text-[#D92D20]"
                        };
                        break;
                    case 3:
                        color = {
                            colorBg: "bg-[#D9F4D4]",
                            colorText: "text-[#039855]"
                        };
                        break;
                }

                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },
        {
            field: "locationName",
            headerName: "Vehicle Current Location",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "x",
            headerName: "Action",
            align: "center",
            width: 120,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {
                            params?.row?.maintenanceStatusId === 3
                                ? (
                                    <Tooltip title="Maintenance has been converted to a repair order">
                                        <IconButton>
                                            <Done sx={{ fontSize: "14px", color: "blue" }} />
                                        </IconButton>
                                    </Tooltip>

                                ) : (params?.row?.maintenanceStatusId === 2
                                    ? (
                                        <Tooltip title="Set to Pending">
                                            <IconButton
                                                onClick={() => {
                                                    if (!pleaseWaitPopup) {
                                                        setPleaseWaitPopup(true);

                                                        axios
                                                            .put(
                                                                `${baseURL}maintenance/UpdateMaintenanceStatus/${params?.row?.id},${1},${auth?.id}`,
                                                                {},
                                                                {
                                                                    headers: {
                                                                        'X-Tenant-ID': tenantId,
                                                                        "Content-Type": "application/json"
                                                                    },
                                                                    withCredentials: true,
                                                                }
                                                            )
                                                            .then(() => {
                                                                setPleaseWaitPopup(false);
                                                                setPaginationModel({
                                                                    page: 0,
                                                                    pageSize: paginationModel.pageSize,
                                                                })
                                                                handleTenantError(null);
                                                            })
                                                            .catch((error) => {
                                                                setPleaseWaitPopup(false);
                                                                handleTenantError(error);
                                                            });
                                                    }
                                                }}
                                            >
                                                <WatchLater sx={{ fontSize: "14px", color: "blue" }} />
                                            </IconButton>
                                        </Tooltip>
                                    ) : (
                                        <>
                                            <Tooltip title="Create Repair Order">
                                                <IconButton
                                                    onClick={() =>
                                                        navigate("/fleet/maintenance/createrepairorder", {
                                                            state: params.id,
                                                        })
                                                    }
                                                >
                                                    <Build
                                                        sx={{
                                                            fontSize: "14px",
                                                            color: "blue",
                                                            transform: "rotate(90deg)",
                                                        }}
                                                    />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Skip Maintenance">
                                                <IconButton
                                                    onClick={() => {
                                                        setConfirmData({
                                                            title: 'Alert',
                                                            summary: 'If you Skipped this maintenance the next alert will be created in the next interval applicable from the settings. This action can not be reverted',
                                                            confirmBtn: 'Yes',
                                                            isConfirm: (callback: any) => {
                                                                if (!pleaseWaitPopup) {
                                                                    setPleaseWaitPopup(true);

                                                                    axios
                                                                        .put(
                                                                            `${baseURL}maintenance/UpdateMaintenanceStatus/${params?.row?.id},${2},${auth?.id}`,
                                                                            {},
                                                                            {
                                                                                headers: {
                                                                                    'X-Tenant-ID': tenantId,
                                                                                    "Content-Type": "application/json"
                                                                                },
                                                                                withCredentials: true,
                                                                            }
                                                                        )
                                                                        .then(() => {
                                                                            setPleaseWaitPopup(false);
                                                                            setPaginationModel({
                                                                                page: 0,
                                                                                pageSize: paginationModel.pageSize,
                                                                            })
                                                                            handleTenantError(null);
                                                                        })
                                                                        .catch((error) => {
                                                                            setPleaseWaitPopup(false);
                                                                            handleTenantError(error);
                                                                        });
                                                                }

                                                                callback();
                                                            }
                                                        });

                                                        setConfirmPopup(true);
                                                    }}
                                                >
                                                    <ContentCut sx={{ fontSize: "14px", color: "blue" }} />
                                                </IconButton>
                                            </Tooltip>
                                        </>
                                    ))
                        }
                    </Box>
                );
            },
        },
    ];
    const [columns, setColumns] = useState<GridColDef[]>(initialColumns);
    const [selectedColumns, setSelectedColumns] = useState(initialColumns?.map(col => col?.headerName));

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColumnFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setColumnFilterAnchorEl(event.currentTarget);
    };
    const handleColumnFilterClose = () => {
        setColumnFilterAnchorEl(null);
    };

    const toggleColumn = (headerName: string) => {
        setSelectedColumns(prev =>
            prev.includes(headerName) ? prev.filter(col => col !== headerName) : [...prev, headerName]
        );
    };

    useEffect(() => {
        const filterCol = initialColumns?.filter(col => selectedColumns?.includes(col?.headerName));
        setColumns(filterCol);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedColumns])

    const toggleAll = () => {
        if (selectedColumns?.length === initialColumns?.length) {
            setSelectedColumns([]);
        } else {
            setSelectedColumns(initialColumns?.map(col => col?.headerName));
        }
    };

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                pageSize: paginationModel.pageSize,
            };

            setPaginationModel(newPaginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false);
            emptySearchApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const emptySearchApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}maintenance/GetMaintenanceReportPaging/${newPaginationModel.page},${newPaginationModel.pageSize}`, {
            method: "GET",
            headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "application/json"
            },
        })
            .then((res) => res.json())
            .then((data) => {
                const result = data.maintenanceReport.map((item: any) => {
                    return {
                        ...item,
                        lastMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                            new Date(item.lastMaintenaceDate)
                        ),
                        nextMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                            new Date(item.nextMaintenaceDate)
                        ),
                    };
                });

                setSearchTableData(result);
                setTotalLength(data.count);
                setLoading(false);
                handleTenantError(null);
            })
            .catch((error) => {               
                handleTenantError(error);
                setSearchTableData([]);
                setLoading(false);
            });
    }

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    pageSize: paginationModel?.pageSize,
                };

                setPaginationModel(newPaginationModel);
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            apiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const apiCall = (newPaginationModel: any) => {
        let filterData: any[] = [];
        setLoading(true);
        switch (maintenanceFilterValue) {
            case 0:
                fetch(`${baseURL}maintenance/GetMaintenanceReportSearchWithMaintenanceTypeNamePaging?maintenanceTypeName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                    method: "GET",
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                })
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.maintenanceReport.map((item: any) => {
                            return {
                                ...item,
                                lastMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.lastMaintenaceDate)
                                ),
                                nextMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.nextMaintenaceDate)
                                ),
                            };
                        });

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setLoading(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);                       
                        handleTenantError(error);
                    });
                break;
            case 1:
                fetch(`${baseURL}maintenance/GetMaintenanceReportSearchWithVehicleNamePaging?vehicleName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                    method: "GET",
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                })
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.maintenanceReport.map((item: any) => {
                            return {
                                ...item,
                                lastMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.lastMaintenaceDate)
                                ),
                                nextMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.nextMaintenaceDate)
                                ),
                            };
                        });

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setLoading(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);                       
                        handleTenantError(error);
                    });
                break;
            case 2:
                fetch(`${baseURL}maintenance/GetMaintenanceReportSearchWithMaintenanceStatusNamePaging?maintenanceStatusName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                    method: "GET",
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                })
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.maintenanceReport.map((item: any) => {
                            return {
                                ...item,
                                lastMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.lastMaintenaceDate)
                                ),
                                nextMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.nextMaintenaceDate)
                                ),
                            };
                        });

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setLoading(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);                      
                        handleTenantError(error);
                    });
                break;
            case 3:
                fetch(`${baseURL}maintenance/GetMaintenanceReportSearchWithLocationNamePaging?locationName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                    method: "GET",
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                })
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.maintenanceReport.map((item: any) => {
                            return {
                                ...item,
                                lastMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.lastMaintenaceDate)
                                ),
                                nextMaintenaceDate: new Intl.DateTimeFormat("en-US").format(
                                    new Date(item.nextMaintenaceDate)
                                ),
                            };
                        });

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setLoading(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setSearchTableData([]);
                        setTotalLength(0);
                        setLoading(false);                        
                        handleTenantError(error);
                    });
                break;
        }
    }


    return (
        <>
            <div className="w-full mt-2">
                <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Maintenance</h2>

                            <div >
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                                    aria-controls={columnFilterOpen ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={columnFilterOpen ? 'true' : undefined}
                                    onClick={handleColumnFilterClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>Columns</span>
                                        <span className={`material-symbols-outlined text-[18px] font-light ${themeStyles.main.textHeadingColor}`}>
                                            filter_alt
                                        </span>
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={columnFilterAnchorEl}
                                    open={columnFilterOpen}
                                    onClose={handleColumnFilterClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: 170,
                                                maxHeight: 300,
                                                backgroundColor: themeStyles.topBar.bg
                                            }
                                        }
                                    }}
                                >
                                    <div className="flex items-center gap-2 px-[16px] py-[6px] w-full">
                                        <input
                                            type="checkbox"
                                            className="form-checkbox cursor-pointer"
                                            checked={selectedColumns?.length === initialColumns?.length ? true : false}
                                            onClick={toggleAll}
                                        />
                                        <span className={`${themeStyles.topBar.tailwindTextColor} font-medium text-[12px]`}>Select All</span>
                                    </div>
                                    <Divider className="w-full" />
                                    {
                                        initialColumns?.map((column, index) => ([
                                            <MenuItem
                                                key={`${index}-Item`}
                                                sx={{
                                                    fontSize: "12px",
                                                    marginBlock: "0px",
                                                    "&: hover": {
                                                        cursor: "default"
                                                    }
                                                }}
                                            >
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox cursor-pointer"
                                                        checked={selectedColumns.includes(column?.headerName)}
                                                        onChange={() => toggleColumn(column?.headerName || "")}
                                                    />
                                                    <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{column?.headerName}</span>
                                                </div>

                                            </MenuItem>,
                                            <Divider key={`${index}-Divider`} className="w-full" />
                                        ]
                                        ))
                                    }
                                </Menu>
                            </div>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <div>
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>{selectedFilter}</span>
                                        {open ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                                            keyboard_arrow_up
                                        </span> : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                                            keyboard_arrow_down
                                        </span>}
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                backgroundColor: themeStyles.topBar.bg
                                            }
                                        }
                                    }}
                                >
                                    {
                                        filterItems?.map((filter, index) => ([
                                            <MenuItem
                                                key={`${index}-Item`}
                                                sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                onClick={() => {
                                                    setSelectedFilter(filter.label)
                                                    setMaintenanceFilterValue(filter.id)
                                                    setAnchorEl(null);

                                                }}>
                                                <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{filter.label}</span>
                                            </MenuItem>,
                                            <Divider key={`${index}-Divider`} className="w-full" />
                                        ]
                                        ))
                                    }
                                </Menu>
                            </div>
                            <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border ${themeStyles.main.borderColor} shadow-sm`}>
                                <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                    search
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchValue}
                                    className={`border-none outline-none w-full ${themeStyles.main.textSubHeadingColor} bg-transparent`}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: themeStyles.table.headerBg,
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}